import { InjectionToken, NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { ForgetPassComponent } from './forget-pass/forget-pass.component';
import { LoginRegisterUiService } from './login-register-ui.service';
import { LoginRegisterWrapperComponent } from './login-register-wrapper.component';
import { LoginUserComponent } from './login-user/login-user.component';
import { NewPassComponent } from './new-pass/new-pass.component';
import { OtpStepperComponent } from './otp-stepper/otp-stepper.component';
import { RegisterComponent } from './register/register.component';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const WINDOW = new InjectionToken<Window>('Window', {
  providedIn: 'root',
  factory: () => window,
});

const routes: Routes = [{ path: '', component: LoginRegisterWrapperComponent }];

@NgModule({
  declarations: [
    LoginRegisterWrapperComponent,
    OtpStepperComponent,
    RegisterComponent,
    LoginUserComponent,
    ForgetPassComponent,
    NewPassComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
  ],
  providers: [
    LoginRegisterUiService,
    {
      provide: WINDOW,
      useFactory: (platformId: Object) => {
        return isPlatformBrowser(platformId) ? window : {};
      },
      deps: [PLATFORM_ID],
    },
  ]
})
export class LoginRegisterModule {}
